<template>
    <div>用户</div>
</template>

<script>
export default {
    name:"UserIndex"
}
</script>

<style >

</style>